import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';

const Wrapper = styled.div``;

const Row = styled.div`
  display: flex;
  height: ${props => (props.isTable ? 'auto' : rem(16))};
  align-items: center;
  background: #f0f0f0;
  padding: ${rem(8)};
  border-top: solid ${rem(1)} #dedede;
`;

const Label = styled.div`
  width: ${rem(300)};
  font-size: ${rem(16)};
  color: #434245;
`;

const GroupLabel = styled(Label)`
  font-weight: bold;
`;

const Value = styled.div``;

class DescriptionParamTable extends React.Component {
  render() {
    const { data } = this.props;

    const notGrouped = data
      .filter(d => d.group === 'not-grouped')
      .map(d => d.params)
      .flat();

    const grouped = data.filter(d => d.group !== 'not-grouped');

    return (
      <Wrapper>
        {notGrouped.map(n => (
          <Row isTable={n.isTable}>
            <Label>{n.label}</Label>
            <Value>{n.value}</Value>
          </Row>
        ))}
        {grouped.map(g => (
          <React.Fragment>
            <Row>
              <GroupLabel>{g.group}</GroupLabel>
            </Row>
            {g.params.map(n => (
              <Row isTable={n.isTable}>
                <Label style={{ paddingLeft: rem(4) }}>{n.label}</Label>
                <Value>{n.value}</Value>
              </Row>
            ))}
          </React.Fragment>
        ))}
      </Wrapper>
    );
  }
}

DescriptionParamTable.propTypes = {
  data: PropTypes.arrayOf({}),
};

DescriptionParamTable.defaultProps = {
  firm: 'SK',
  description: '',
  data: [],
};

export default DescriptionParamTable;



// WEBPACK FOOTER //
// ./src/Components/DescriptionParamTable/index.jsx